import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './CardSliderBlock.scss';

// @ts-ignore
import Reveal from "react-reveal/Reveal";

import Card from "../../Elements/Card/Card";
import Title from "../../Elements/Title/Title";
import { sendEvent } from '../../../utils';

interface ICardSliderBlockProps {
  context?: IContent;
}

const CardSliderBlock = ({ context }: ICardSliderBlockProps) => {
  const { cards } = context;
  return (
    <Reveal onReveal={() => sendEvent("compare preorder advantages - tab displayed - scroll")}>
      <div className="block-cards">
        <div className="content">
          <Title headline={cards.title.headline} baseline={cards.title.baseline} color="#E9E2CF" />
          <div className="card-slider-container">
            <ul className="card-slider">
              {cards.list.map((card: any, index: number) => (
                <Card key={index} info={card} index={index} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Reveal>
  );
};

export default withContent(CardSliderBlock);
